import Img from '@/components/atomic/atoms/layout/image/img/styled';
import View from '@/components/atomic/atoms/layout/view/styled';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const PictureComponent = styled(View)<BasicComponentProps>(
	({ $aspectRatio, $flex }) => ({
		display: 'inline-block',
		aspectRatio: $aspectRatio,
		flex: $flex,

		[`${Img}`]: {
			display: 'block',
		},
	}),
).withComponent('picture');

const Picture = withExposer(PictureComponent, 'picture');

export default Picture;
